import { createAsyncThunk } from '@reduxjs/toolkit';
import { getUser } from '../services/getUser.service';
import { setUser } from 'store/actions/setUser';
import { setDevIdentity } from 'utils/devIdentity';

export const loadUser = createAsyncThunk(
  'user/loadUser',
  async (_, { dispatch }) => {
    const user = await getUser();
    // getUser always hits the deployed API, so user.id is our real Cognito
    // identity id. No-op outside a dev build. See utils/devIdentity.
    setDevIdentity(user?.id);
    dispatch(setUser(user));
    return user;
  }
);
